import {
  getThemeClass,
  getThemeComponentClasses,
} from "@/src_new/shared/lib/themeComponentClasses";

type AuthIdentifierFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  type?: "email" | "tel";
  disabled?: boolean;
  required?: boolean;
};

export default function AuthIdentifierField({
  label,
  value,
  onChange,
  placeholder,
  type = "email",
  disabled,
  required,
}: AuthIdentifierFieldProps) {
  const inputClasses = getThemeComponentClasses().input;

  return (
    <div>
      <label className="text-sm font-semibold text-theme-text-muted">{label}</label>
      <input
        type={type}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`mt-2 w-full rounded-xl border px-4 py-3 focus:outline-none ${getThemeClass(inputClasses.borderColor, "border-theme-border")} ${getThemeClass(inputClasses.bgColor, "bg-theme-surface-muted")} ${getThemeClass(inputClasses.textColor, "text-theme-text")} ${getThemeClass(inputClasses.placeholderColor, "placeholder:text-theme-text-placeholder")} ${getThemeClass(inputClasses.focusBorderColor, "focus:border-theme-primary")} ${inputClasses.base}`}
      />
    </div>
  );
}
